'use client'

import { useEffect, useMemo, useState } from 'react'
import { useAppSession } from '@/state/session/context'

function readNavigatorOnline() {
  if (typeof window === 'undefined') return true
  return window.navigator.onLine
}

export function useOnlineStatus() {
  const { session } = useAppSession()
  const [navigatorOnline, setNavigatorOnline] = useState(true)

  useEffect(() => {
    const sync = () => setNavigatorOnline(readNavigatorOnline())
    sync()
    window.addEventListener('online', sync)
    window.addEventListener('offline', sync)
    return () => {
      window.removeEventListener('online', sync)
      window.removeEventListener('offline', sync)
    }
  }, [])

  return useMemo(() => {
    const forced = Boolean(session.network.forceOffline)
    return {
      isOnline: forced ? false : navigatorOnline,
      isForcedOffline: forced,
    }
  }, [navigatorOnline, session.network.forceOffline])
}
